import useProfile from "@/hooks/use-profile";
import { getHomePage } from "@/utilities/functions/getHomePage";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PageLoader from "@/components/page-loader";

function Home() {
  const { profile } = useProfile();
  const [defaultPath, setDefaultPath] = useState<string>("");

  useEffect(() => {
    setDefaultPath(getHomePage(profile?.defaultHomeRoute));
  }, [profile?.id, profile?.defaultHomeRoute]);

  if (!defaultPath)
    return (
      <PageLoader loading>
        <></>
      </PageLoader>
    );

  return <Navigate to={defaultPath} replace />;
}

export default Home;
